module.exports = __webpack_public_path__ + "img/Bild3.27812cfb.jpg";